/**
 * Proxies the theme bell ([data-bis-proxy]) to Back in Stock Alert Engine.
 * App mount point in admin: .buy-buttons__notify (see buy-buttons.liquid).
 */
(function () {
  if (window.__hpBisProxyBound) return;
  window.__hpBisProxyBound = true;

  const LAUNCH_BUTTON_SELECTOR = [
    ".email-me-inlineButton",
    "#product-restore-email .email-me-button",
    ".email-me-button:not(.email-me-submitButton)"
  ].join(",");
  const PRESERVED_HOST_ID = "bis-native-launcher-host";
  // Marker on the URL that tells a freshly-loaded page to auto-open the notify popup — set by the
  // reload fallback below when the shopper clicked the bell on an AJAX-selected sold-out variant.
  const AUTO_OPEN_PARAM = "bis_open";

  // The Back in Stock Alert Engine popup is injected by the app after the page loads,
  // so its copy cannot be translated in a Liquid template. Apply the Vietnamese copy
  // whenever that injected popup is present.
  function localizePopup(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const popups = [];

    if (scope.matches && scope.matches(".popup_senfinrbox")) popups.push(scope);
    popups.push.apply(popups, scope.querySelectorAll(".popup_senfinrbox"));

    popups.forEach(function (popup) {
      const title = popup.querySelector(".popup_senf_h_title");
      const submitButton = popup.querySelector(".email-me-submitButton");
      const nameInput = popup.querySelector(".buyer-name");
      const emailInput = popup.querySelector(".buyer-email");
      const terms = popup.querySelector(".lightntify");

      if (title) title.textContent = "NHẬN THÔNG BÁO KHI CÓ HÀNG";
      if (submitButton) {
        submitButton.textContent = "NHẬN THÔNG BÁO KHI CÓ HÀNG";
        submitButton.value = "NHẬN THÔNG BÁO KHI CÓ HÀNG";
      }
      if (nameInput) nameInput.placeholder = "Họ và tên...";
      if (emailInput) emailInput.placeholder = "Địa chỉ email...";
      if (terms) {
        terms.textContent =
          "HUONG sẽ gửi thông báo qua email ngay khi sản phẩm có hàng trở lại. Chúng tôi không chia sẻ địa chỉ email của bạn với bên thứ ba.";
      }
    });
  }

  // Has the Back in Stock app injected its launcher anywhere yet (buy area OR the preserved host)?
  function launcherExists() {
    return !!document.querySelector(LAUNCH_BUTTON_SELECTOR);
  }

  function getPreservedHost() {
    let host = document.getElementById(PRESERVED_HOST_ID);
    if (host) return host;

    host = document.createElement("div");
    host.id = PRESERVED_HOST_ID;
    host.hidden = true;
    host.setAttribute("aria-hidden", "true");
    document.body.appendChild(host);

    return host;
  }

  function getSelectedVariantId(trigger) {
    const scope =
      trigger?.closest("product-form") ||
      trigger?.closest("product-rerender") ||
      trigger?.closest(".product-info") ||
      document;
    const variantJson = scope.querySelector("script[data-variant]")?.textContent;

    if (variantJson) {
      try {
        const variant = JSON.parse(variantJson);
        if (variant?.id) return String(variant.id);
      } catch (_error) {
        // Fall through to the URL/form fallbacks below.
      }
    }

    const variantFromUrl = new URL(window.location.href).searchParams.get("variant");
    if (variantFromUrl) return variantFromUrl;

    const selectedInput = scope.querySelector("form[action*=\"/cart/add\"] input[name=\"id\"]:not([disabled])");
    return selectedInput?.value ? String(selectedInput.value) : "";
  }

  function syncSelectedVariant(variantId) {
    if (!variantId) return;

    const variantSelect = document.querySelector("select[name=\"buyer_selected_variant\"]");
    if (!variantSelect) return;

    const hasVariantOption = Array.from(variantSelect.options).some(function (option) {
      return option.value === variantId;
    });

    if (!hasVariantOption || variantSelect.value === variantId) return;

    variantSelect.value = variantId;
    variantSelect.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function preserveLaunchButton(scope) {
    const host = getPreservedHost();
    const roots = [scope, document].filter(Boolean);

    for (const root of roots) {
      const launchBtn = Array.from(root.querySelectorAll(LAUNCH_BUTTON_SELECTOR)).find(function (button) {
        return !host.contains(button);
      });

      if (launchBtn) {
        host.appendChild(launchBtn);
        return launchBtn;
      }
    }

    return host.querySelector(LAUNCH_BUTTON_SELECTOR);
  }

  function findLaunchButton(scope) {
    return preserveLaunchButton(scope);
  }

  function openBisPopup(scope, trigger) {
    const launchBtn = findLaunchButton(scope);
    if (launchBtn) {
      const selectedVariantId = getSelectedVariantId(trigger);

      syncSelectedVariant(selectedVariantId);
      launchBtn.click();
      window.setTimeout(function () {
        syncSelectedVariant(selectedVariantId);
      }, 0);

      return true;
    }

    return false;
  }

  function openWithRetry(scope, trigger) {
    if (openBisPopup(scope, trigger)) return;

    let attempts = 0;
    const timer = window.setInterval(function () {
      if (openBisPopup(scope, trigger) || ++attempts >= 50) {
        window.clearInterval(timer);
      }
    }, 200);
  }

  preserveLaunchButton();
  localizePopup(document);

  const observer = new MutationObserver(function (mutations) {
    preserveLaunchButton();
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.ELEMENT_NODE) localizePopup(node);
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener("click", function (event) {
    const trigger = event.target.closest("[data-bis-proxy]");
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    const scope =
      trigger.closest("product-form") ||
      trigger.closest("product-rerender") ||
      trigger.closest(".product-info");

    // Fast path: the app already injected its launcher (page loaded on a sold-out variant, or a
    // warm navigation) — open the popup right now.
    if (launcherExists()) {
      openWithRetry(scope, trigger);
      return;
    }

    // The Back in Stock app injects its launcher ONLY for the variant present at page load; it does
    // not react to the theme's AJAX variant switch. So when a shopper picks a sold-out colour/size
    // client-side, no launcher ever exists to click (verified: injects in ~1s when loaded on the
    // sold-out variant, never within 12s after a client-side switch). Reload onto the selected
    // variant — which makes the app inject on load — and auto-open the popup once it does.
    const variantId = getSelectedVariantId(trigger);
    const url = new URL(window.location.href);
    if (variantId) url.searchParams.set("variant", variantId);
    url.searchParams.set(AUTO_OPEN_PARAM, "1");
    window.location.assign(url.toString());
  });

  // Arrived via the reload fallback above: strip the flag (so a manual refresh won't re-open) and
  // open the popup as soon as the app injects its launcher for this now-page-load sold-out variant.
  // openWithRetry polls up to ~10s, covering the ~1s cold injection.
  (function autoOpenAfterReload() {
    const url = new URL(window.location.href);
    if (url.searchParams.get(AUTO_OPEN_PARAM) !== "1") return;

    url.searchParams.delete(AUTO_OPEN_PARAM);
    window.history.replaceState({}, document.title, url.toString());

    openWithRetry(document, null);
  })();
})();
